import { BaseComponent } from "utils/base-component"
import { SignUp } from "components/signup/index"

export default class IncentiveWrapper extends BaseComponent {
  static cssClass = "leaflet__incentive-wrapper"
  incentive: SignUp

  init() {
    const closeWrapper = this.root.querySelector(".leaflet__incentive-close-wrapper")
    closeWrapper.addEventListener("click", () => {
      this.toggle(false)
    })
  }

  toggle(force?: boolean) {
    if (!this.incentive) {
      this.initIncentive()
    }
    this.toggleModifier("hidden", !force)
  }

  initIncentive() {
    const incentiveEl = this.root.querySelector(".leaflet__incentive")
    this.incentive = new SignUp(incentiveEl, undefined)
  }
}
